import styles from './AdjustmentDetail.css'
import _ from 'lodash'

class InventoryAdjustment extends React.Component {
  render () {
    let {adjustmentDetail, namespace} = this.props
    let lastItemId = 0
    return (this._shouldRender() && <div>
      {this._header()}
      <div className='row'>
        <div className='col-sm-12'>
          <div className={styles['separator-row']} />
        </div>
      </div>
      {namespace === 'ingredients' && this._renderIngredientHistoryDetails()}
      {namespace === 'items' && adjustmentDetail.history_details.map((history, idx) => {
        const dom = (
          <div>
            {history.item_variant_name && <div>
              {lastItemId !== history.item_id && <div className='row'>
                <div className='col-sm-12'>
                  <div>{history.item_name}</div>
                  <div className={styles['separator-row']} />
                </div>
              </div>}
              <div className={'col-sm-5 pl-0px ' + styles['variant-name']}>
                <div>&nbsp; &nbsp; {history.item_variant_name}</div>
              </div>
            </div>}
            {!history.item_variant_name && <div className='col-sm-5 pl-0px'>
              <div>{history.item_name}</div>
            </div>}
            <div className='col-sm-2 text-center'>
              <div>{history.beginning_stock}</div>
            </div>
            <div className='col-sm-3 text-center'>
              <div>{history.end_stock}</div>
            </div>
            <div className='col-sm-2 pr-0px text-center'>
              <div>{history.adjustment}</div>
            </div>
            <div className='row'>
              <div className='col-sm-12'>
                <div className={styles['separator-row']} />
              </div>
            </div>
          </div>
        )
        lastItemId = history.item_id
        return dom
      })}
      {namespace === 'items' && <div className='row'>
        <div className={'col-sm-10 ' + styles['label-total']}>
          TOTAL
        </div>
        <div className={'col-sm-2 ' + styles['total-adj']}>
          {this._getTotalAdjustment(adjustmentDetail.history_details)}
        </div>
      </div>}
    </div>)
  }

  _getTotalAdjustment = (historyDetails) => {
    let total = 0
    for (let i = 0; i < historyDetails.length; i++) {
      total += historyDetails[i].adjustment
    }
    return total
  }

  _shouldRender = () => {
    const {namespace, adjustmentDetail, ingredientAdjustmentDetail} = this.props
    if (namespace === 'items') {
      return !!adjustmentDetail
    } else {
      return !!ingredientAdjustmentDetail
    }
  }

  _header = () => {
    const {namespace} = this.props
    if (namespace === 'items') {
      return <div className='row mt-40px mb-5px ml-0px mr-0px'>
        <div className='col-sm-5 pl-0px'>
          {this._headerCol('inventory adjustment')}
        </div>
        <div className='col-sm-2 text-center'>
          {this._headerCol('in stock')}
        </div>
        <div className='col-sm-3 text-center'>
          {this._headerCol('actual stock')}
        </div>
        <div className='col-sm-2 pr-0px text-center'>
          {this._headerCol('adjustment')}
        </div>
      </div>
    } else {
      return <div className='row mt-40px mb-5px ml-0px mr-0px'>
        <div className='col-sm-4 pl-0px'>
          {this._headerCol('inventory adjustment')}
        </div>
        <div className='col-sm-2 text-center'>
          {this._headerCol('in stock')}
        </div>
        <div className='col-sm-2 text-center'>
          {this._headerCol('actual stock')}
        </div>
        <div className='col-sm-2 text-center'>
          {this._headerCol('adjustment')}
        </div>
        <div className='col-sm-2 pr-0px text-center'>
          {this._headerCol('unit')}
        </div>
      </div>
    }
  }

  _headerCol = (title) => {
    return <div className={styles['label-adj-detail']}>{title}</div>
  }

  _renderIngredientHistoryDetails = () => {
    let {ingredientAdjustmentDetail} = this.props
    const historyDetails = _.sortBy(ingredientAdjustmentDetail.ingredient_history_details, ['unit_name'])
    const doms = []
    const total = {
      quantity: 0,
      unit_name: ''
    }
    historyDetails.forEach((history, idx) => {
      const dom = (
        <div>
          <div className='row'>
            <div className={styles['row-inventory']}>
              <div className='col-sm-4'>
                {history.ingredient_name}
              </div>
              <div className='col-sm-2 text-center'>
                {history.beginning_stock}
              </div>
              <div className='col-sm-2 text-center'>
                {history.end_stock}
              </div>
              <div className='col-sm-2 text-center'>
                {history.adjustment_quantity}
              </div>
              <div className='col-sm-2 text-center'>
                {history.unit_name}
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12'>
              <div className={styles['separator-row']} />
            </div>
          </div>
        </div>
      )
      doms.push(dom)
      total.quantity += history.adjustment_quantity
      total.unit_name = history.unit_name
      // give 'total row' if the next unit name is different or this is last row
      if (idx + 1 >= historyDetails.length || historyDetails[idx + 1].unit_name !== total.unit_name) {
        doms.push(
          <div>
            <div className='row mb-30px'>
              <div className={styles['row-inventory']}>
                <div className={`col-sm-4 ${styles['label-total']}`}>
                  TOTAL
                </div>
                <div className={`col-sm-2 col-sm-offset-4 text-center ${styles['label-total']}`}>
                  {total.quantity}
                </div>
                <div className={`col-sm-2 text-center ${styles['label-unit-total']}`}>
                  {total.unit_name}
                </div>
              </div>
            </div>
            {idx + 1 < historyDetails.length && <div className='row'>
              <div className='col-sm-12'>
                <div className={styles['separator-row']} />
              </div>
            </div>}
          </div>)
        total.quantity = 0
      }
    })
    return doms
  }
}

InventoryAdjustment.propTypes = {
  adjustmentDetail: React.PropTypes.Object
}

export default InventoryAdjustment



// WEBPACK FOOTER //
// ./app/pages/Inventory/Adjustment/AdjustmentDetail/InventoryAdjustment.js